import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useBroadcast = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: { messageType: string; payload: any }) =>
      axiosRequest
        .post(`${baseUrl}/broadcast/${value.messageType}`, value.payload)
        .then((res) => {
          return res.data;
        }),
  });
};
